

export default {
    name: 'browse',
    props: ['browseData'],
    data() {
        return {

        }
    },
    watch: {
        browseData(val) {
            this.source = val
        }
    },
    methods: {
        jumpDetails(id) {

            let routeData = this.$router.resolve({
                path: `/discussion/${id}`,
            });
            window.open(routeData.href, '_blank');
        },
        randomBgColor() {
            let color = ['#50B5FF', '#3DD598', '#FC5A5A']
            return color[parseInt(3 * Math.random())]
        }
    }
}
